const Loading = ()=>{
    return(
        <p>Cargando...</p>
    )
}
export default Loading